module.exports = __webpack_public_path__ + "static/media/image_3.02dcc1e3.svg";